import Login from "../features/Login/Login";
import Loading from "../features/Login/LoadingDialog"
import { MainBox } from "./Styles";
import { useParams } from 'react-router-dom'
import React, { useEffect, useState, useMemo, MouseEventHandler, useLayoutEffect } from "react";
import AlertDialog from '../features/Login/AlertDialog'
import { SubmitFormData } from "../data/loginService"
import { NewUserData, InvalidateUserDetails } from "../data/interfaces/userInfo";
import { LoginNav } from "../features/Login/FormNavigation";


const LoginPage = () => {
  const user: NewUserData = {
    userId: 0,
    workstationId: 0,
    firstName: "",
    email: "",
    mfaPhone: "",
    isMFAVerified: 0,
    birthDate: "",
  };
  const [AlertID, setAlertID] = useState(1);
  const [MultiOption, SetMultiOption] = useState(true)
  const [isLoading, setLoading] = useState({ loading: false })
  const [isLoginPaused, setLoginPause] = useState(false)
  const [showPopup, setShowPopup] = useState(false);
  const [showMsg, setShowMsg] = useState(false);
  const [formState, setFormState] = useState("");
  const { form } = useParams();
  const [validMFA, setvalidMFA] = useState(true);
  const [userInfo, setUserInfo] = useState<NewUserData>(user);
  const [formDisplay, setFormDisplay] = useState("UserLogin");

  const toggleChildMenu = (data: boolean): void => {
    //var win = window.open(`${window.location.origin}/request/1/${data}`, '_self');

    if (data && userInfo) {
      let userData: InvalidateUserDetails = {
        UserId: userInfo?.userId,
        EmployeeId: userInfo?.employeeId,
        AccountNumber: userInfo?.accountNumber,

      };
      SubmitFormData(userData, "InvalidateSession", setvalidMFA)
    }
    setShowPopup(false);
  }

  useEffect(() => {

    if (userInfo.userId !== 0 && userInfo.alertId == 0) {
      setFormDisplay(LoginNav(true, userInfo))
    }
  }, [userInfo]);

  const toggleLoading = (): void => {
    setLoading({ loading: true });
  }

  const handleAlertIdChange = (newError: number) => {
    if (newError == AlertID) {
      setShowPopup(true)
    }
    else {
      setAlertID(newError);
    }

  }

  useEffect(() => {
    if (AlertID >= 700 && AlertID < 800) {
      SetMultiOption(true);
      setShowPopup(true);
      setShowMsg(false);

    } else if (AlertID >= 600 && AlertID < 700) {
      SetMultiOption(false);
      setShowPopup(true);
      setShowMsg(true);

    }

    if (AlertID >= 800 && AlertID < 900) {
      setShowPopup(false);
      setShowMsg(true);
      SetMultiOption(false);
    }
  }, [AlertID])

  useEffect(() => {
    if (form) {
      setFormState(form)
    }
  }, [form]);

  return (
    <MainBox>
      <AlertDialog MultiOption={MultiOption} isOpen={showPopup} handleClose={toggleChildMenu} alertId={AlertID} onAlertIdChange={handleAlertIdChange} />
      <Loading isOpen={isLoading.loading} />
      <Login formFromURL={formState} setLoginPause={setLoginPause} onAlertIdChange={handleAlertIdChange} alertId={AlertID} isOpen={showMsg} setLoading={toggleLoading} isLoginPaused={isLoginPaused} validMFA={validMFA} setvalidMFA={setvalidMFA} setUserInfo={setUserInfo} userInfo={userInfo} setFormDisplay={setFormDisplay} formDisplay={formDisplay} />
    </MainBox>
  );
}

export default LoginPage;